module.exports = __webpack_public_path__ + "media/images/reservation_check_markreservation_circle_mark-6f07711dc610f5a4eee233ac17e94a4b.svg";